"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmountDeriver__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "InexactFraction",
        type: "error",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b50603f80601d6000396000f3fe6080604052600080fdfea26469706673582212201a9539d12cd5e2754332de8377ececf8e8fdcf55d447ec0bc03bc6c8c8e7c34164736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class AmountDeriver__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.AmountDeriver__factory = AmountDeriver__factory;
AmountDeriver__factory.bytecode = _bytecode;
AmountDeriver__factory.abi = _abi;
//# sourceMappingURL=AmountDeriver__factory.js.map